import React from 'react'

const ViewQRLocation = () => {
  return (
    <div>ViewQRLocation</div>
  )
}

export default ViewQRLocation